import { ViewerQuery } from "../api/generated/graphql";

export const isCaregiver = (viewer?: ViewerQuery["viewer"]) =>
  !!viewer?.roles.find((role) => role.roleType === "CAREGIVER");
